import { render } from "./KarussellFeiern4.vue?vue&type=template&id=809fd40a"
import script from "./KarussellFeiern4.vue?vue&type=script&lang=js"
export * from "./KarussellFeiern4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__